import React from "react";
import { Container, Logo, BasicText, Heading, LongImage } from "../styles";
import coverImage from "../assets/coverpage.png";

import styled from "styled-components";
import { FaNpm, FaGithub } from "react-icons/fa";
import { IconContext } from "react-icons";

const IconSet = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const SpecialLongImage = styled(LongImage)`
  @media (min-width: 600px) {
    display: flex;
    justify-content: center;
    margin-top: 40px;
    margin-bottom: 70px;
  }
`;

class Home extends React.Component {
  render() {
    return (
      <Container>
        <Logo>react-native-normalized</Logo>
        <BasicText
          style={{
            textAlign: "center",
            margin: 4
          }}
        >
          Components that behave more consistently between iOS and Android
        </BasicText>

        <IconSet>
          <IconContext.Provider value={{ color: "#FF0080", size: 30 }}>
            <a
              href="https://github.com/Kida007/react-native-normalized"
              style={{ padding: 5, marginRight: 10 }}
            >
              <FaGithub />
            </a>
          </IconContext.Provider>
          <IconContext.Provider value={{ color: "#FF0080", size: 45 }}>
            <a
              href="https://www.npmjs.com/package/react-native-normalized"
              style={{ padding: 5 }}
            >
              <FaNpm />
            </a>
          </IconContext.Provider>
        </IconSet>

        <div style={{ marginTop: 10 }}>
          <SpecialLongImage>
            <div style={{ overflow: "visible" }}>
              <img src={coverImage} />
            </div>
          </SpecialLongImage>

          <Heading>Make Consistent React Native Components</Heading>

          <BasicText>
            React Native's built-in components render slightly different on iOS
            and Android, causing you to spend extra time making the UI more
            consistent across devices. For example, did you know that when you
            create a fresh project using react-native init, the color of a Text
            is by default #000000 on iOS and #808080 on Android? <br /> <br />
            This project provides you with slightly adjusted adaptions of
            built-in React Native components with the goal of being more
            consistent between platforms. Think of it as normalize.css for React
            Native.
            <br />
            To be clear, these are not bugs in React Native, rather RN opts to
            preserve the default behavior on each platform as much as possible.
            Nonetheless, you might prefer to use components that behave more
            consistently.
          </BasicText>
        </div>
      </Container>
    );
  }
}

export default Home;
